import { render, staticRenderFns } from "./DicePanel.vue?vue&type=template&id=3630a14e&scoped=true&lang=pug&"
import script from "./DicePanel.vue?vue&type=script&lang=js&"
export * from "./DicePanel.vue?vue&type=script&lang=js&"
import style0 from "./DicePanel.vue?vue&type=style&index=0&id=3630a14e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3630a14e",
  null
  
)

component.options.__file = "DicePanel.vue"
export default component.exports